import type { ICustomControlData } from './customControlData';
import { decodeHolterIndications } from '../../../../../../common/customControls/holterIndicationsAndMedications';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { List } from '../../../../elements/List/List';

interface IIndicatieReadProps {
    customControlData: ICustomControlData;
}

export function IndicatieRead(props: IIndicatieReadProps) {
    if (
        !(
            props.customControlData.indicatie.dyspnoeDeffort ||
            props.customControlData.indicatie.controleTherapie ||
            props.customControlData.indicatie.hartfalen ||
            props.customControlData.indicatie.ritmeGeleidingsstoornissen ||
            props.customControlData.indicatie.decompensatioCordis ||
            props.customControlData.indicatie.duizeling ||
            props.customControlData.indicatie.ventrikelHypertrofie ||
            props.customControlData.indicatie.hartkloppingen ||
            props.customControlData.indicatie.kleplijden ||
            props.customControlData.indicatie.verdenkingIschemie ||
            props.customControlData.indicatie.hypertensie ||
            props.customControlData.indicatie.typischeAngina ||
            props.customControlData.indicatie.algemeenOnderzoek ||
            props.customControlData.indicatie.atypischeAngina ||
            props.customControlData.indicatie.geruststelling ||
            props.customControlData.indicatie.andersText
        )
    ) {
        return null;
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>Indicatie</FormLabel>
            <InputContainer>
                <List
                    bold
                    items={decodeHolterIndications(props.customControlData)}
                />
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
